import React, { useContext } from 'react'
import './M_TimeLine.css'
import { useMediaQuery, Tooltip } from '@mui/material'
import { LoadingContext } from '../M_Utils'
import Brightness1Icon from '@mui/icons-material/Brightness1'
import PropTypes from 'prop-types'

export function MTimeLine({
    valueTimeline, color, timeLineBreak, bottomPosition, forceVertical, subHeaderSize, timeLineRowPosition
}) {

    const timelineBreakValue = typeof timeLineBreak === 'number' ? `${timeLineBreak}px` : timeLineBreak || '600px'
    const matches = useMediaQuery(`(max-width:${timelineBreakValue})`)
    const ctx = useContext(LoadingContext)

    const isVertical = forceVertical || matches
    const timelineItems = Array.isArray(valueTimeline) ? valueTimeline : []
    const timelineCount = Math.max(timelineItems.length, 1)
    const newColor = color || ctx.primaryColor || 'var(--color-black)'
    const contentPosition = bottomPosition || timeLineRowPosition === 'bottom' ? 'bottom' : 'top'

    const renderHeader = (item) => {
        const content = (
            <div className='mTimelineHeaderContent' style={{ fontSize: subHeaderSize || '14px' }}>
                {item.subHeader === '' || item.subHeader === undefined || item.subHeader === null ? (
                    item.header
                ) : (
                    <>
                    <b>{item.header}</b>
                    {item.subHeader}
                    </>
                )}
            </div>
        )

        return item.toolTipLabel ? <Tooltip title={item.toolTipLabel}>{content}</Tooltip> : content
    }

    const timelineMarker = (item) => {
        return (
            <div className='mTimelineMarker' style={{ color: newColor }} >
                {(item.marker) || <Brightness1Icon style={{ color: newColor }} />}
            </div>
        )
    }

    const renderHorizontalTimeline = () => (
        <ol
            className={`mTimeline mTimelineHorizontal mTimelineHorizontal-${contentPosition}`}
            style={{
                '--m-timeline-color': newColor,
                '--m-timeline-count': timelineCount,
                '--m-timeline-min-width': `${timelineCount * 120}px`
            }}
        >
            {timelineItems.map((item, index) => (
                <li
                    key={item.id || item.header || index}
                    className={`mTimelineHorizontalItem ${index === 0 ? 'mTimelineFirstItem' : ''} ${index === timelineItems.length - 1 ? 'mTimelineLastItem' : ''}`}
                >
                    <div className='mTimelineContentSlot mTimelineContentTop'>
                        {contentPosition === 'top' && renderHeader(item)}
                    </div>
                    <div className='mTimelineMarkerRow'>
                        <span className='mTimelineConnector mTimelineConnectorBefore' />
                        {timelineMarker(item)}
                        <span className='mTimelineConnector mTimelineConnectorAfter' />
                    </div>
                    <div className='mTimelineContentSlot mTimelineContentBottom'>
                        {contentPosition === 'bottom' && renderHeader(item)}
                    </div>
                </li>
            ))}
        </ol>
    )

    const renderVerticalTimeline = () => (
        <ol className='mTimeline mTimelineVertical' style={{ '--m-timeline-color': newColor }}>
            {timelineItems.map((item, index) => (
                <li
                    key={item.id || item.header || index}
                    className={`mTimelineVerticalItem ${index === 0 ? 'mTimelineFirstItem' : ''} ${index === timelineItems.length - 1 ? 'mTimelineLastItem' : ''}`}
                >
                    <div className='mTimelineVerticalMarkerColumn'>
                        <span className='mTimelineConnector mTimelineConnectorBefore' />
                        {timelineMarker(item)}
                        <span className='mTimelineConnector mTimelineConnectorAfter' />
                    </div>
                    <div className='mTimelineVerticalContent'>
                        {renderHeader(item)}
                    </div>
                </li>
            ))}
        </ol>
    )

    return (
        <div className='principalDivM_TimeLine'>
            <div className='divM_TimeLine'>
                {isVertical ? renderVerticalTimeline() : renderHorizontalTimeline()}
            </div>
        </div>
    )
}

MTimeLine.propTypes = {
    valueTimeline: PropTypes.array,
    color: PropTypes.string,
    timeLineBreak: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    bottomPosition: PropTypes.bool,
    forceVertical: PropTypes.bool,
    subHeaderSize: PropTypes.string,
    timeLineRowPosition: PropTypes.oneOf(['top', 'bottom']),
}
